import React from "react";
import styled from "styled-components";

export interface DividerProps {
    orientation?: "horizontal" | "vertical";
    color?: string;
}

const DividerRoot = styled.hr<DividerProps>`
    border: none;
    ${({ orientation, color, theme }) => {
        if (orientation === "vertical") {
            return `
                width: 1px;
                height: 100%;
                background-color: ${color || theme.palette.grey};
            `;
        }
        return `
            width: 100%;
            height: 1px;
            background-color: ${color || theme.palette.grey};
        `;
    }}
`;

export const Divider: React.FC<DividerProps> = ({ orientation = "horizontal", color }) => {
    return <DividerRoot orientation={orientation} color={color} />;
};

export default Divider;


